import { Send } from "lucide-react";

const WHATSAPP_PHONE = "+919310745117"; // Replace with your WhatsApp number
const WHATSAPP_MESSAGE = "Hi! I'm interested in your services. Can we discuss?";

export default function FloatingWhatsAppButton() {
    const whatsappURL = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

    return (
        <a
            href={whatsappURL}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110 group"
            title="Chat with us on WhatsApp"
            data-testid="floating-whatsapp-button"
        >
            <Send size={20} className="text-white group-hover:scale-125 transition-transform duration-300" />
        </a>
    );
}
